// extracted by mini-css-extract-plugin
export var columnItem = "_fw-3";
export var columnItemDraggable = "_fw-5";
export var dragHandle = "_fw-0";
export var dragHandleHovered = "_fw-1";
export var dropdown = "_fw-6";
export var dropdownContent = "_fw-8";
export var dropdownInner = "_fw-7";
export var filterDropdownHeader = "_fw-9";
export var icon = "_fw-2";
export var moveToTopButton = "_fw-4";
export var sectionDivider = "_fw-a";